<template>
  <div class="bubble-label">
    <span>{{ title }}</span>
    <div class="arrow"></div>
  </div>
</template>

<script>
export default {
  name: "BubbleLabel",
  props: ['title']
}
</script>

<style scoped lang="scss">

.bubble-label {
  position: relative;
  display: inline-block;
  background-color: $sub-color;
  border-radius: 12px;
  padding: 0 10px 1px;
  font-size: 13px;
  color: #fff;
  font-weight: bold;
  line-height: 23px;

  .arrow {
    position: absolute;
    bottom: -5px;
    left: calc(50% - 4.5px);
    width: 0;
    height: 0;
    border-left: 4.5px solid transparent;
    border-right: 4.5px solid transparent;
    border-top: 5px solid $sub-color;
  }
}
</style>
